/* @flow */

export type ButtonVariant =
    | 'primary'
    | 'secondary'
    | 'orange'
    | 'danger'
    | 'save'
    | 'ai-blue'
    | 'support'
    | 'upgrade'
    | 'text'
    | 'text-primary'
    | 'text-secondary'
    | 'text-danger'
    | 'text-add';

export const BUTTON_VARIANTS: ButtonVariant[] = [
    'primary',
    'secondary',
    'orange',
    'danger',
    'save',
    'ai-blue',
    'support',
    'upgrade',
    'text',
    'text-primary',
    'text-secondary',
    'text-danger',
    'text-add',
];

export type ButtonSize = 'mini' | 'tiny' | 'small' | 'normal' | 'big' | 'xlarge';
